import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';

@Injectable()
export class InventoryEntryDetFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetResumeByDeliveryCode(deliveryCode, organizationId = null): Observable<RequestResponse<any>> {
        if (organizationId == null) {
            return this._httpClient.get<RequestResponse<any>>(this._urlBase + 'api/InventoryEntryDet/Web?deliveryCode=' + deliveryCode);
        } else {
            return this._httpClient.get<RequestResponse<any>>(this._urlBase + 'api/InventoryEntryDet/Web?deliveryCode=' + deliveryCode + '&organizationId=' + organizationId);
        }
    }
}
